import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils';
export const tabsTriggerVariants = cva(cn(['inline-flex items-center justify-center whitespace-nowrap', 'data-[state=active]:text-strong text-assistive disabled:text-disabled', 'data-[state=active]:border-strong border-b-2 border-transparent ', 'data-[state=active]:hover:bg-strong-alternative hover:bg-alternative',
// disabled 탭은 호버해도 배경이 바뀌지 않는다(누를 수 있는 것처럼 보이지 않게).
// disabled 상태에만 걸리므로 활성/비활성 탭의 기존 호버 동작에는 영향이 없다.
'disabled:hover:bg-transparent', 'rounded-tr-xs rounded-tl-xs']), {
  variants: {
    size: {
      md: 'max-h-[52px] min-w-[80px] p-sm text-heading-md-bold',
      sm: 'max-h-[32px] min-w-[64px] px-sm py-2xs text-body-lg-bold'
    }
  },
  defaultVariants: {
    size: 'md'
  }
});
export interface TabsTriggerProps extends React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>, VariantProps<typeof tabsTriggerVariants> {}
const TabsTrigger = React.forwardRef<React.ElementRef<typeof TabsPrimitive.Trigger>, TabsTriggerProps>(({
  className,
  size,
  ...props
}, ref) => <TabsPrimitive.Trigger ref={ref} className={cn(tabsTriggerVariants({
  size
}), className)} {...props} />);
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
export { TabsTrigger };